module.exports = __webpack_public_path__ + "img/m_info.261de4b2.png";